// DailyPositive backend (DailyPositiveServer) — mobil uygulama ile aynı API
export const API_CONFIG = {
  // Ortam değişkeni ile override: REACT_APP_API_URL (ör. yerel veya staging)
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.morkivilcim.com',
  
  // API Endpoints - DailyPositive API
  ENDPOINTS: {
    // Admin panel (IsAdmin = 1, JWT) — DailyPositive AdminAuthController
    ADMIN_LOGIN: '/api/admin/auth/login',

    // Authentication (DailyPositive AuthController — mobil uygulama)
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    PROFILE: '/api/auth/profile',

    // SentenceInfo tablosu (admin)
    SENTENCE_INFO: '/api/admin/sentence-info',

    // 21 Günlük Olumlama Programı (admin)
    AFFIRMATION_PLANS: '/api/admin/affirmation-plans',

    // iOS Winback kampanyası + abone olmayanlara birebir bildirim (admin)
    WINBACK: '/api/admin/winback',
    
    // Support System (DailyPositive AdminSupportController)
    SUPPORT_TICKETS: '/api/admin/support/tickets',
    SUPPORT_CATEGORIES: '/api/categories', // DailyPositive CategoriesController
    SUPPORT_MESSAGES: '/api/admin/support/tickets',
    SUPPORT_STATISTICS: '/api/admin/support/statistics',
    
    // Support Categories (DailyPositive SupportCategoryController)
    SUPPORT_CATEGORY_LIST: '/api/support/categories',
    
    // Test endpoints
    HEALTH_CHECK: '/api/test/health',
  },
  
  // Request Timeout (milliseconds)
  TIMEOUT: 10000,
  
  // Retry Configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
};

// API Response Types
export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
  errors?: string[];
}

export interface PaginatedResponse<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

// Error Types
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public response?: any
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

// Request Headers Helper
export const getAuthHeaders = (token?: string) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// API URL Helper
export const buildApiUrl = (endpoint: string, params?: Record<string, string>) => {
  const url = new URL(`${API_CONFIG.BASE_URL}${endpoint}`);
  
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url.searchParams.append(key, value);
      }
    });
  }
  
  return url.toString();
};
